"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconApple = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconApple = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M16.528 11.573C16.552 14.3 18.97 15.2 19 15.21c-.015.063-.379 1.3-1.286 2.555-.757 1.107-1.55 2.187-2.81 2.207-1.226.028-1.637-.704-3.042-.704-1.417 0-1.856.684-3.03.732-1.2.043-2.117-1.181-2.902-2.277-1.569-2.237-2.79-6.304-1.153-9.072.794-1.357 2.241-2.231 3.787-2.255 1.201-.024 2.317.792 3.055.792.725 0 2.103-.976 3.525-.831.594.017 2.287.23 3.38 1.784-.089.052-2.017 1.159-1.996 3.432m-2.312-6.687c-.66.759-1.714 1.339-2.741 1.265-.134-1.025.387-2.115.969-2.779.658-.755 1.8-1.332 2.715-1.372.12 1.065-.312 2.115-.943 2.886" })] })));
};
exports.IconApple = IconApple;
exports.IconApple.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconApple;
